export default __webpack_public_path__ + "static/dj-acec6953c639741662690d1c15377fb6.jpg";